import React from 'react';
import { ThemeProvider } from 'styled-components';
import { Popover } from '@amzn/storm-ui';

export const CustomPopper = (props) => {
  const modifyPopoverZIndex = (theme) => {
    return {
      ...theme,
      popover: {
        ...theme.popover,
        zIndex: props.zIndex,
      },
    };
  };

  return (
    <ThemeProvider theme={modifyPopoverZIndex}>
      <Popover {...props} />
    </ThemeProvider>
  );
};
